(function($, Drupal, drupalSettings) {

  Drupal.behaviors.preload_assets = {
    attach: function (context, settings) {


      /**
      * Hide removed item.
      */
      $('.remove-item', context).once('remove-item').on('click', function() {
        
        var $this = $(this);
        var $thisItem = $this.closest('tr.draggable');
        var removeButton = $('.remove-item');

        $thisItem.hide();

        // Disable remove item button.
        removeButton.addClass('disabled').after('<div class="ajax-wrapper"><div class="ajax-progress__throbber"></div></div>');
       
      });

 
      /**
      * Disable and clear Crossorigin when no applicable.
      */
      $('.asset-type', context).once('disable-crossorigin').on('change', function() {

        var $this = $(this);
        var $thisValue = $this.val();
        var $thisAssetOrigin = $this.closest('tr.draggable').find('.asset-origin');

        if ( $thisValue != 'font' && $thisValue != 'fetch' && $thisValue != '' ) {
          $thisAssetOrigin.prop('disabled', true).val('');
        } else {
          $thisAssetOrigin.prop('disabled', false);
        }

      }); $('.asset-type').trigger('change');


    }
  }; //Drupal.behaviors.preload_assets

})(jQuery, Drupal, drupalSettings);
